module.exports = __webpack_public_path__ + "static/media/folders-modal-multiselect.b1b88cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/folders-modal-multiselect.png
// module id = 1487
// module chunks = 0